import React from "react";
import {
  DashboardOutlined,
  ClusterOutlined,
  TeamOutlined,
  UserAddOutlined,
  UserOutlined,
  PlusSquareOutlined,
  PlusCircleOutlined,
  OrderedListOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { Route } from "@ant-design/pro-layout/lib/typings";
import routes from "constants/routes";
// const UsersView = React.lazy(() => import("./users/UsersListView"));
const routeConfig: Route = {
  path: routes.ADMIN_DASHBOARD,
  routes: [
    {
      name: "Dashboard",
      icon: <DashboardOutlined />,
      path: routes.ADMIN_DASHBOARD,
    },
    {
      name: "站点管理",
      icon: <EnvironmentOutlined />,
      path: routes.ADMIN_STATIONS,
      routes: [
        {
          path: routes.ADMIN_STATIONS,
          name: "站点列表",
          icon: <OrderedListOutlined />,
        },
        {
          path: routes.ADMIN_ADD_STATION,
          name: "新建站点",
          icon: <PlusSquareOutlined />,
        },
      ],
    },
    {
      name: "设备类型管理",
      icon: <ClusterOutlined />,
      path: routes.ADMIN_DEVICE_TYPES,
      routes: [
        {
          path: routes.ADMIN_DEVICE_TYPES,
          name: "设备类型列表",
          icon: <OrderedListOutlined />,
        },
        {
          path: routes.ADMIN_ADD_DEVICE_TYPE,
          name: "新建设备类型",
          icon: <PlusCircleOutlined />,
        },
      ],
    },
    {
      name: "用户管理",
      icon: <UserOutlined />,
      path: routes.ADMIN_USERS,
      // component: UsersView,
      component: './users/UsersListView',
    },
  ],
};

export default routeConfig;
